"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var config = {
  logService: "//search-vbi-logging-pxyr3x5scunznbej2b4rtkb6su.us-east-1.es.amazonaws.com",
  logIndex: "webcaster_ng",
  logLevel: "off", //off, fatal, warn, debug
  timeService: "https://checkip.mediaplatform.com",
  service: "mp",
  region: "us-east-1"
};

exports.default = config;